import React from 'react';

import { useSelector } from 'react-redux';

import { userSelector } from '../../reducers/current-user-selectors';

import { MessageItem } from '../../messages/components/message-item';

import { MESSAGE_TYPE } from '../../util/message-types';
import { confirm } from '../../widgets/confirmation-dialog';

type InputProps<T> = {
  messageBody: string;
  template: T;
  isSelected: boolean;

  onEdit: () => void;
  onDelete: (template: T) => void;
};

export const TextMessageTemplate = <T extends Template>({
  messageBody,
  template,
  onDelete,
  onEdit,
  isSelected,
}: InputProps<T>) => {
  const user = useSelector(userSelector);

  const handleDelete = async () => {
    if (await confirm('Are you sure you would like to delete this message?')) {
      onDelete(template);
    }
  };

  return (
    <MessageItem
      senderName={`${user.firstName} ${user.lastName}`}
      messageType={MESSAGE_TYPE.TEXT}
      messageBody={messageBody}
      className="u-width-100"
      colorOverrideClass={`${
        isSelected ? 'u-background-actionMuted' : 'u-background-white u-backgroundHover-neutral3'
      }`}
      onEditMessage={onEdit}
      onDeleteMessage={handleDelete}
      dataCy="template-message"
      includesHTML
      doNotTrim
      isPreview
    />
  );
};
